import { render, staticRenderFns } from "./EvoucherShopDetail.vue?vue&type=template&id=278701e3&scoped=true&"
import script from "./EvoucherShopDetail.vue?vue&type=script&lang=js&"
export * from "./EvoucherShopDetail.vue?vue&type=script&lang=js&"
import style0 from "./EvoucherShopDetail.vue?vue&type=style&index=0&id=278701e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278701e3",
  null
  
)

export default component.exports